import { generateModules, routes } from '@/router';
import { defineStore } from 'pinia';
import { isArray } from '@/utils/is';

/** 动态路由文件 */
const asyncModules = require.context('../router/modules/dynamic', true, /(.*)\.js/);

/** 动态路由 */
const asyncRoutes = [
  ...generateModules(asyncModules),
  { path: '*', redirect: '/404', meta: { hidden: true } }
];

/**
 * 路由鉴权
 * @param route 当前路由
 * @param roles 权限列表
 */
const hasPermission = (route, roles, isAdmin) => {
  if (route.meta?.roles) {
    if (isArray(route.meta.roles)) {
      return route.meta.roles.findIndex(s => roles.includes(s)) > -1;
      // const index = route.meta.roles.findIndex(s => s === 'isAdmin');
      // if (index > -1) {
      //   return !!isAdmin;
      // }
      // return roles.some(role => route.meta?.roles?.includes(role));
    }
    return roles.includes(route.meta.roles);
  }
  return true;
};

/**
 * 过滤路由列表
 * @param _routes 路由列表
 * @param roles 权限列表
 */
const filterAsyncRoutes = (_routes, roles, isAdmin) => {
  const result = [];
  _routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(tmp, roles, isAdmin)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles, isAdmin);
      }
      result.push(tmp);
    }
  });
  return result;
};

/**
 * 路由排序，仅排序一级路由
 */
const sortRoutes = _routes => {
  _routes.sort((a, b) => {
    if (a.meta && b.meta) {
      return (a.meta.sort ?? 0) - (b.meta.sort ?? 0);
    }
    return -1;
  });
  return _routes;
};

export const useRouteStore = defineStore('route', {
  state() {
    return {
      routes: []
    };
  },
  actions: {
    /**
     * 生成路由
     * @param roles 角色列表
     */
    generateRoutes(roles, isAdmin) {
      return new Promise(resolve => {
        const accessRoutes = filterAsyncRoutes(asyncRoutes, roles, isAdmin);
        this.routes = [...accessRoutes];
        resolve();
      });
    }
  },
  getters: {
    accessRoutes: state => sortRoutes([...routes, ...state.routes])
  }
});
